import React from 'react'

import { createRoot } from 'react-dom/client'

import ReactPixel from 'react-facebook-pixel'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-time-picker/dist/TimePicker.css'
import 'react-calendar/dist/Calendar.css'
/* eslint-disable import/no-extraneous-dependencies */
import 'react-phone-number-input/style.css'

// eslint-disable-next-line max-len
import { BuilderGate } from './containers/mobile-builder-notice/MobileBuilderNotice'
import i18n from './i18n'
import { resolveBuilderLanguage } from './utils/builderLanguage'
import reportWebVitals from './utils/statistics/reportWebVitals'

const options = {
    autoConfig: true,
    debug: false,
}

if (process.env.REACT_APP_FACEBOOK_PIXEL_ID) {
    ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID, undefined, options)
    ReactPixel.pageView()
}

const language = resolveBuilderLanguage()

if (i18n.language !== language) {
    i18n.changeLanguage(language)
}

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)

root.render(
    <React.StrictMode>
        <BuilderGate />
    </React.StrictMode>,
)

reportWebVitals()
